import { assetsBasePart } from "./constants";

export default {
  all: `${assetsBasePart}/structured-templates`,
  byId: (id: string) => `${assetsBasePart}/structured-templates/${id}`,
  generations: `${assetsBasePart}/structured-template-generations`,
};
